export const extraCoachData = {
	apiEndpoint: '/api/teachermembership/coachsearch',
	paramName: 'name',
	apiResponseKey: 'coachDetails',
	dataKey: 'contactId',
	dataEventName: 'coachSelect',
	valueKey: 'fullName',
	coachFormElement: {
		coachFirstName: {
			errorMessage: 'Enter first name of a coach',
			id: 'coachFirstName',
			label: 'Coach First Name'
		},
		coachLastName: {
			errorMessage: 'Enter last name of a coach',
			id: 'coachLastName',
			label: 'Coach Last Name'
		}
	}
};

export const extraSchoolData = {
	apiEndpoint: '/api/teachermembership/schoolsearch',
	paramName: 'name',
	apiResponseKey: 'school',
	dataKey: 'schoolId',
	dataEventName: 'schoolSelect',
	valueKey: 'schoolName',
	keepTypingLength: 0,
	additionalSearchParam: {
		userType: ""
	},
	finderType: 'school',
	addressFormElement: {
		schoolName: {
			errorMessage: 'Enter a school name',
			id: 'school-name-address',
			label: 'School Name',
			hasLimit: true,
			charLimit: 3
		},
		addressLine1: {
			errorMessage: 'Enter address line 1',
			id: 'address-line1',
			label: 'Address Line 1',
			hasLimit: true,
			charLimit: 3
		},
		addressLine2: {
			errorMessage: 'Enter address line 2',
			id: 'address-line2',
			label: 'Address Line 2',
			hasLimit: true,
			charLimit: 3
		},
		county: {
			errorMessage: 'Enter town',
			id: 'address-town',
			label: 'Town',
			hasLimit: true,
			charLimit: 3
		},
		postcode: {
			errorMessage: 'Enter postcode',
			id: 'address-postcode',
			label: 'Postcode',
			hasLimit: true,
			charLimit: 3
		}
	}
};

export const extraAddressData = {
	apiEndpoint: '/api/teachermembership/schoolsearch',
	paramName: 'name',
	apiResponseKey: 'school',
	dataKey: 'schoolId',
	dataEventName: 'schoolSelect',
	valueKey: 'schoolName',
	keepTypingLength: 0,
	additionalSearchParam: {
		userType: ""
	},
	placeHolder: 'Search for your address',
	addressFormElement: {
		mailingStreet: {
			errorMessage: 'Enter Mailing Street',
			id: 'mailing-street',
			label: 'Mailing Street',
			hasLimit: true,
			charLimit: 3
		},
		town: {
			errorMessage: 'Enter Mailing City',
			id: 'town',
			label: 'City',
			hasLimit: true,
			charLimit: 3
		},
		county: {
			errorMessage: 'Enter Town',
			id: 'county',
			label: 'County',
			hasLimit: true,
			charLimit: 3
		},
		postcode: {
			errorMessage: 'Enter Postcode',
			id: 'postcode',
			label: 'Postcode',
			hasLimit: true,
			charLimit: 3
		}
	}
};

export const extraUniversityData = {
	apiEndpoint: '/api/teachermembership/schoolsearch',
	paramName: 'name',
	apiResponseKey: 'school',
	dataKey: 'schoolId',
	dataEventName: 'schoolSelect',
	valueKey: 'schoolName',
	keepTypingLength: 0,
	additionalSearchParam: {
		userType: "ITT"
	},
	finderType: 'university',
	addressFormElement: {
		schoolName: {
			errorMessage: 'Enter a school name',
			id: 'school-name-address',
			label: 'University Name',
			hasLimit: true,
			charLimit: 3
		},
		addressLine1: {
			errorMessage: 'Enter address line 1',
			id: 'address-line1',
			label: 'Address Line 1',
			hasLimit: true,
			charLimit: 3
		},
		addressLine2: {
			errorMessage: 'Enter address line 2',
			id: 'address-line2',
			label: 'Address Line 2',
			hasLimit: true,
			charLimit: 3
		},
		county: {
			errorMessage: 'Enter town',
			id: 'address-town',
			label: 'Town',
			hasLimit: true,
			charLimit: 3
		},
		postcode: {
			errorMessage: 'Enter postcode',
			id: 'address-postcode',
			label: 'Postcode',
			hasLimit: true,
			charLimit: 3
		}
	}
};

export const extraTournamentData = {
	apiEndpoint: '/api/officials/tournament',
	paramName: 'name',
	apiResponseKey: 'tournament',
	dataKey: 'tournamentId',
	dataEventName: 'tournamentSelect',
	valueKey: 'tournamentCode',
	keepTypingLength: 0,
	tournamentFormElement: {
		tournamentCode: {
			errorMessage: 'Enter a tournament Code',
			id: 'tournament-code',
			label: 'Tournament Code',
			hasLimit: true,
			charLimit: 3
		},
		tournamentName: {
			errorMessage: 'Enter a tournament name',
			id: 'tournament-name',
			label: 'Tournament Name',
			hasLimit: true,
			charLimit: 3
		},
		tournamentStartDate: {
			questionType : 'duetDateComponent',
			placeholder: 'YYYY-MM-DD',
			errorMessage: 'Enter tournament start date',
			id: 'tournament-start-date',
			label: 'Tournament Start Date',
			hasLimit: true,
			maxPastYears: {
				amount: 50,
				errorMessage: 'Please enter a valid tournament starting date'
			}
		},
		tournamentEndDate: {
			questionType : 'duetDateComponent',
			placeholder: 'YYYY-MM-DD',
			errorMessage: 'Enter tournament end date',
			id: 'tournament-end-date',
			label: 'Tournament End Date',
			hasLimit: true,
			maxPastYears: {
				amount: 50,
				errorMessage: 'Please enter a valid tournament completion date'
			}
		},
		tournamentGrade: {
			questionType: 'select',
			errorMessage: 'Please select a tournament grade',
			id: 'tournament-grade',
			label: 'Tournament Grade',
			placeholder: 'Please select a tournament grade',
			hasLimit: true,
			charLimit: 1,
			options: [
				{
					id: '1',
					label: '1'
				},
				{
					id: '2',
					label: '2'
				},
				{
					id: '3',
					label: '3',
				},
				{
					id: '4',
					label: '4'
				},
				{
					id: '5',
					label: '5'
				},
				{
					id: '6',
					label: '6'
				},
				{
					id: '7',
					label: '7'
				},
				{
					id: '8',
					label: 'ATP'
				},
				{
					id: '9',
					label: 'TE'
				},
				{
					id: '10',
					label: 'ITF'
				},
				{
					id: '11',
					label: 'WTA'
				},
				{
					id: '12',
					label: 'Wheelchair'
				},
				{
					id: '13',
					label: 'Ungraded Recreational'
				}
			]
		},
		tournamentVenue: {
			errorMessage: 'Enter Venue',
			id: 'tournament-venue',
			label: 'Venue',
			hasLimit: true,
			charLimit: 3
		},
		tournamentRefreeName: {
			errorMessage: 'Enter Referee Name',
			id: 'refree-name',
			label: 'Referee Name',
			hasLimit: true,
			charLimit: 3
		}
	}
};

export const extraCountyData = {
	apiEndpoint: '/api/teachermembership/getcounty',
	paramName: 'name',
	apiResponseKey: 'county',
	dataKey: 'countyName',
	dataEventName: 'countySelect'
};

export const extraCoachVenueSearchData = {
	// TODO CSA: this endpoint is not confirmed
	apiEndpoint: '/api/coaches/getvenue',
	paramName: 'name',
	apiResponseKey: 'venue',
	dataKey: 'id',
	dataEventName: 'venueSelect',
	valueKey: 'venueName',
	venueType: 'venue',
	addressFormElement: {
		venueName: {
			errorMessage: 'Enter a venue name',
			id: 'venue-name-address',
			label: 'Venue Name',
			hasLimit: true,
			charLimit: 3
		},
		addressLine1: {
			errorMessage: 'Enter address line 1',
			id: 'address-line1',
			label: 'Address Line 1',
			hasLimit: true,
			charLimit: 3
		},
		addressLine2: {
			errorMessage: 'Enter address line 2',
			id: 'address-line2',
			label: 'Address Line 2',
			hasLimit: true,
			charLimit: 3
		},
		county: {
			errorMessage: 'Enter town',
			id: 'address-town',
			label: 'Town',
			hasLimit: true,
			charLimit: 3
		},
		postcode: {
			errorMessage: 'Enter postcode',
			id: 'address-postcode',
			label: 'Postcode',
			hasLimit: true,
			charLimit: 3
		}
	}
};

export const extraParkData = {
	apiEndpoint: '/api/parksactivators/getVenue',
	paramName: 'name',
	apiResponseKey: 'venue',
	dataKey: 'id',
	dataEventName: 'parkSelect',
	valueKey: 'venueName',
	venueType: 'park',
	keepTypingLength: 0,
	addressFormElement: {
		venueName: {
			errorMessage: 'Enter a park name',
			id: 'park-name-address',
			label: 'Park Name',
			hasLimit: true,
			charLimit: 3
		},
		addressLine1: {
			errorMessage: 'Enter address line 1',
			id: 'address-line1',
			label: 'Address Line 1',
			hasLimit: true,
			charLimit: 3
		},
		addressLine2: {
			errorMessage: 'Enter address line 2',
			id: 'address-line2',
			label: 'Address Line 2',
			hasLimit: true,
			charLimit: 3
		},
		county: {
			errorMessage: 'Enter town',
			id: 'address-town',
			label: 'Town',
			hasLimit: true,
			charLimit: 3
		},
		postcode: {
			errorMessage: 'Enter postcode',
			id: 'address-postcode',
			label: 'Postcode',
			hasLimit: true,
			charLimit: 3
		}
	}
};

export const extraMentorData = {
	apiEndpoint: '/api/coachdetails/getmentor',
	paramName: 'name',
	apiResponseKey: 'mentor',
	dataKey: 'name',
	dataEventName: 'mentorSelect',
	valueKey: 'name',
	venueType: 'mentor',
	keepTypingLength: 0
};
export const extraDbsVenueData = {
	apiEndpoint: '/api/dbs/searchOrganisationListByName',
	paramName: 'orgName',
	apiResponseKey: 'response',
	dataKey: 'organisationShortCode',
	dataEventName: 'organisationSelect',
	valueKey: 'organisationName',
	keepTypingLength: 0,
	instructionText:
		'You can search by using the name of the venue. Results will appear after you type three characters.',
	placeHolder: 'Type the Venue Name',
	id: 'dbs-venue',
	errorMessage: 'Please select a venue'
};

export const extraAuthorityData = {
	apiEndpoint: '/api/parksactivators/getLocalAuthoritySearch',
	paramName: 'name',
	apiResponseKey: 'venue',
	dataKey: 'id',
	dataEventName: 'authoritySelect',
	valueKey: 'venueName',
	venueType: 'authority',
	keepTypingLength: 0
};
